import Request from "../lib/request";

const baseUrl = process.env.REACT_APP_API_URL;

export const getList = () => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "get",
    url: baseUrl + "/projects/" + projectId + "/bankAccountList",
    needToken: true,
    params: {
      paginate: false
    }
  });
};

export const getAll = () => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "get",
    url: baseUrl + "/projects/" + projectId + "/bankAccounts",
    needToken: true,
    params: {
      paginate: false
    }
  });
};

export const show = (id) => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "get",
    url: baseUrl + "/projects/" + projectId + "/bankAccounts/" + id,
    needToken: true,
    params: {
      paginate: false
    }
  });
};

export const store = data => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "post",
    url: baseUrl + "/projects/" + projectId + "/bankAccounts",
    needToken: true,
    data: data
  });
};

export const update = (id, data) => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "put",
    url: baseUrl + "/projects/" + projectId + "/bankAccounts/" + id,
    needToken: true,
    data: data
  });
};

export const remove = id => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "delete",
    url: baseUrl + "/projects/" + projectId + "/bankAccounts/" + id,
    needToken: true
  });
};
